import React, { useState ,useContext} from 'react'
import Bg from  '../../assets/slide4.jpg';
import Logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faInfo } from '@fortawesome/free-solid-svg-icons';

import './signup.css'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import { Link, useNavigate } from 'react-router-dom';
import BackLoader from '../../components/backloader'

function Signup(props) {
const navigate = useNavigate();
  const [user, setUser]= useState({});
  
  const { profile , setProfile, setToken} = useContext(ShareContext);
  const [seePass, setSeePass] = useState(false);
  const [seePass1, setSeePass1] = useState(false);
  const [isSuccess, setIsSuccess] =useState(false);
 // const [isLoading,setIsLoading]= useState(false);

  const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);

    const onRegister=async(e)=>{
      e.preventDefault(); 

        setLoading(true);
        
        try {
          var v={...user};
          const resp = await fetch(`${Constants.apiUrl}/gazette/signup`, {
            method: 'POST',
            body:JSON.stringify(v) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': '',
            },
          });
          
          const data = await resp.json();
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
              //setGazettes(data.gazettes);
              
            setIsSuccess(true);
          }else {   
            setErr('username/password not correct');
          }
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }

       }

    return (
      <div className='signup'>
          <img src={Bg} className='bg-image' alt='Lagos City' />
          <div className="main">
              <div className="logo-text">
                  <img src={Logo} alt="JIS Logo" className='jis-logo'/>
                  <p><a href='http://jisstaging.lagosjudiciary.gov.ng/index.html'>Return to Judiciary home</a></p>
              </div>
              <div className="log-form">
                <div className="bar">
                    <div className="icon">
                        <FontAwesomeIcon icon={faInfo} />
                    </div>
                    <p>e-Affidavits</p>
                </div>
            {isSuccess && <div className="main-form">
                <h1>Registration successful. Please login with your credentials</h1>
                <Link to='/login'>Login with Email and password</Link>
                </div>}    
                {!isSuccess && <div className="main-form">
                      <h2>Register</h2>
                      <form className="form" onSubmit={onRegister}>
                        <div className="inputs">
                            <div className="input">
                              <label htmlFor="firstname">First Name</label>
                              <input type="text" id='firstname' value={user.firstname} onChange={(e)=> setUser({...user, firstname:e.target.value })} required />
                            </div>
                            <div className="input">
                              <label htmlFor="lastname">Last Name</label>
                              <input type="text" id='lastname'  value={user.lastname} onChange={(e)=> setUser({...user, lastname:e.target.value })} required />
                            </div>
                        </div>
                          <div className="input">
                              <label htmlFor="email">Email</label>
                              <input type="email" id='email'  value={user.email} onChange={(e)=> setUser({...user, email:e.target.value })} required/>
                          </div>
                          <div className="inputs">
                            <div className="input">
                                <label htmlFor="phone">Phone Number</label>
                                <input type="tel" id='phone'  value={user.phone} onChange={(e)=> setUser({...user, phone:e.target.value })} required/>
                            </div>
                            <div className="input">
                              <label htmlFor="address">Address</label>
                              <input type="text" id='address'  value={user.address} onChange={(e)=> setUser({...user, address:e.target.value })} required />
                            </div>
                          </div>
                          
                          <div className="inputs">
                            <div className="input">
                                <label htmlFor="password">Password</label>
                                <div className="password">
                                    <input type={!seePass?"password":'text'} id='password'  value={user.password} onChange={(e)=> setUser({...user, password:e.target.value })} required/>
                                    <FontAwesomeIcon icon={!seePass?faEyeSlash:faEye}  onClick={()=>setSeePass(!seePass)} />
                                </div>
                            </div>
                            <div className="input">
                              <label htmlFor="password2">Retype Password</label>
                              <div className="password">
                                  <input type={!seePass1?"password":'text'} id='password2'  value={user.vpassword} onChange={(e)=> setUser({...user, vpassword:e.target.value })} required/>
                                  <FontAwesomeIcon icon={!seePass1?faEyeSlash:faEye}  onClick={()=>setSeePass1(!seePass1)} />
                              </div>
                            </div>
                          </div>
                          <div style={{color:'red', margin:8, textAlign:'center'}}>
                            {err}
                          </div>
                          <div className="continue-stay">
                              <button className='red' type='submit'>Register</button>
                          </div>
                      </form>
                      <div className="reset">
                          <Link to='/login'>Have an account? Login</Link>
                      </div>
                  </div>}  
              </div>
          </div>
          <BackLoader open={loading}  />
      </div>
    )
  }

export default Signup